import { render, staticRenderFns } from "./BookNow.vue?vue&type=template&id=798dd8d0&scoped=true"
import script from "./BookNow.vue?vue&type=script&lang=js"
export * from "./BookNow.vue?vue&type=script&lang=js"
import style0 from "./BookNow.vue?vue&type=style&index=0&id=798dd8d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798dd8d0",
  null
  
)

export default component.exports